import { type ReactElement } from 'react'
import { AuthenticatedLayout } from '../../../../../shared/components/layouts/AuthenticatedLayout'
import {
  RpOccurrenceDetailContainer
} from '../../../../../routes/app/recurring-charges/[id]/rp-occurrence/[id]/RpOccurrenceDetailContainer'

interface Args {
  paymentId: string | number
  occurrenceId: string | number
}
export const buildAppRpOccurrencePath = ({ paymentId, occurrenceId }: Args): string => `/app/recurring-charges/${paymentId}/rp-occurrence/${occurrenceId}`

function RpOccurrencePaymentPage (): ReactElement {
  return <RpOccurrenceDetailContainer />
}

RpOccurrencePaymentPage.getLayout = function getLayout (page: ReactElement) {
  return (
    <AuthenticatedLayout>
      {page}
    </AuthenticatedLayout>
  )
}
export default RpOccurrencePaymentPage
